import { API } from 'aws-amplify';
const sppapi = {};

sppapi.uploadFile = function(initiator, fileName, fieldId, base64Content) {
    sppapi.createUploadUrl(base64Content.length, function(upload) {
        let updated = false;
        for (var i=0; i < initiator.uploads.uploadIds.length; i++) {
            if (initiator.uploads.uploadIds[i].fieldId == fieldId) {
                initiator.uploads.uploadIds[i].id = upload.id;
                initiator.uploads.uploadIds[i].fileName = fileName;
                updated = true;
                console.log('Updated existing ' + fieldId)
                break;
            }
        }

        if (!updated) {
            console.log('Adding new for ' + fieldId)
            initiator.uploads.uploadIds.push({
                id: upload.id,
                fieldId: fieldId,
                fileName: fileName
            })
        }

        let form = new FormData()
        Object.keys(upload.form.fields).forEach(key => form.append(key, upload.form.fields[key]))
        form.append('file', base64Content)
        fetch(upload.form.url, { method: 'POST', body: form}).then(function() {
        }).then(function(res) {
            console.log(res)
            initiator.uploads.uploading--
            if (initiator.uploads.uploading < 0) {
                initiator.uploads.uploading = 0
            }
        })
    })
}

sppapi.createUploadUrl = function(uploadLength, callback) {
    console.log('Getting upload URL');
    let data = {
        body: {
            uploadLength: uploadLength
        }
    }
    API.post('bdmformsapi', '/tasks/files/upload', data).then(callback).catch(err => {
        console.error(err, err.stack)
    })      
}

sppapi.lookupSession = function(submissionId) {
    if (submissionId == '') {
        console.log('No submissionId')
        return
    }

    return API.get('bdmformsapi', '/tasks/sessions/lookup/' + submissionId)
}

sppapi.completeTask = function(initiator) {
    initiator.inProgress = true;
    var formData = JSON.stringify(initiator.form);
    let data = {
        body: {
            taskId: initiator.taskId,
            submissionId: typeof initiator.submissionId !== 'undefined' ? initiator.submissionId : null,
            uploadIds: typeof initiator.uploads !== 'undefined' ? initiator.uploads.uploadIds : [],
            formData: formData
        }
    }

    console.log('Completing task ' + data.body.taskId)
    API.post('bdmformsapi', '/tasks/processes/complete', data).then(function(result) {
        console.log(result);
        initiator.inProgress = false;
        initiator.$emit('submitEnquiry', result);
    }).catch(err => {
        console.error(err, err.stack)
        initiator.inProgress = false;
    })
}

sppapi.startProcessAndCompleteTask = function(initiator) {
    initiator.inProgress = true;
    var formData = JSON.stringify(initiator.form);
    // temp fix till we refactor the forms
    if (!(Object.hasOwn(initiator, 'uploads'))) {
        initiator.uploads = {}
        initiator.uploads.uploadIds = initiator.uploadsIds
    }
    let data = {
        body: {
            processId: initiator.processId,
            formData: formData,
            uploadIds: initiator.uploads.uploadIds,
            contactPhone: initiator.contactPhone || '',
            contactEmail: initiator.contactEmail || ''
        }
    }

    console.log('Starting process ' + data.body.processId)
    API.post('bdmformsapi', '/tasks/processes/start', data).then(function(result) {          
        initiator.$emit('submitEnquiry', result);
    }).catch(err => {
        console.error(err, err.stack)
        initiator.inProgress = false;
    })
}

sppapi.requestToken = function(initiator, barcode, contactPhone, submitWhere) {
    initiator.inProgress = true;
    API.post('bdmformsapi', '/tasks/sessions/token/send', {
        body: {
            contactPhone: contactPhone,
            barcode: barcode,
            submitWhere: submitWhere ?? ''
        }
    }).then(function(result) {
        initiator.inProgress = false;
        initiator.result = result;
        initiator.recordNotFound = result.total == 0;
        initiator.attempts++;
        console.log(result)
    }).catch(err => {
        console.error(err, err.stack)
        initiator.recordNotFound = false;
        initiator.inProgress = false;
        initiator.attempts++;
    })
}

sppapi.verifyToken = function(initiator, token, barcode, contactPhone) {
    console.log('Verifying ' + token)
    initiator.inProgress = true
    initiator.sessionId = ''
    initiator.submissionId = ''
    API.post('bdmformsapi', '/tasks/sessions/token/retrieve', {
        body: {
            token: token,
            barcode: barcode,
            contactPhone: contactPhone
        }
    }).then(function(result) {
        initiator.sessionId = result.sessionId
        initiator.submissionId = result.submissionId
        initiator.tokenNotFound = result.status == 'NOT_FOUND'
        initiator.inProgress = false
    }).catch(err => {
        console.error(err, err.stack)
        initiator.sessionId = ''
        initiator.submissionId = ''
        initiator.inProgress = false
    })
}

export default sppapi;